import { render, staticRenderFns } from "./UserMetricsMenu.vue?vue&type=template&id=55420c26&"
import script from "./UserMetricsMenu.vue?vue&type=script&lang=ts&"
export * from "./UserMetricsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./UserMetricsMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports